import { makeStyles } from "tss-react/mui";
import { constants } from "../../constants";

interface IStyles {
    backgroundImage: string;
}
export const useStyles = makeStyles<IStyles>()(
    (theme, { backgroundImage }) => ({
        root: {
            alignSelf: "center",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            color: constants.color.white,
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            backgroundColor: constants.color.white,

            "&.static-headline": {
                height: "410px",
            },

            "&.entry-point": {
                height: "559px",
            },
        },

        container: {
            width: "100%",
            maxWidth: "1300px",
            height: "100%",
            backgroundImage: `url(${backgroundImage})`,
            backgroundRepeat: "repeat-y",
            backgroundPosition: "center top",
            display: "flex",
            color: constants.color.black,
            flexDirection: "column",
            paddingTop: "120px",
        },

        heading: {
            fontFamily: "Galaxie Copernicus",
            fontSize: "54px",
            fontStyle: "italic",
            fontWeight: 525,
            lineHeight: "70px",
            textAlign: "center",
            marginBottom: "36px",
        },
        message: {
            fontFamily: "Galaxie Copernicus",
            fontSize: "18px",
            fontStyle: "italic",
            fontWeight: 500,
            lineHeight: "32px",
            textAlign: "center",
            whiteSpace: "pre-wrap",
        },
    })
);
